import { StyledBreadcrumbs } from '@/components/styles';
import genLinkParams from '@/lib/generateLinkParams';
import Link from 'next/link';

export default function Breadcrumbs({ items, theme }) {
  return (
    <StyledBreadcrumbs theme={theme}>
      {items.map((item, ind) => {
        const { id, title, type, slug, link } = item;
        const [href, as] = link ? [link, link] : genLinkParams({
          type: type,
          slug: slug,
        });
        return (
          <StyledBreadcrumbs.Item key={id}>
            {ind < items.length - 1 ? (
              <Link href={link || href} as={link || as} shallow={false} passHref>
                <StyledBreadcrumbs.Link>{title}</StyledBreadcrumbs.Link>
              </Link>
            ) : (
              <span>
                <StyledBreadcrumbs.Link as="span">{title}</StyledBreadcrumbs.Link>
              </span>
            )}
          </StyledBreadcrumbs.Item>
        );
      })}
    </StyledBreadcrumbs>
  );
}
